import React from 'react';
import Head from '~/App/shared/components/Head';
import Legacy from './Legacy';
import New from './New';
import { QueryParams } from './types';
import { useTranslation } from '~/Locale';
import { useLocation } from 'react-router';

interface Props {
  data: object;
}

const isLegacyUnsubscription = (query: QueryParams) => {
  return (
    (query.newsletterId && query.hash) ||
    (query.hash && query.template && query.member_id)
  );
};

const Unsubscribe = ({ data }: Props) => {
  const { search } = useLocation();
  const searchParams = new URLSearchParams(search);
  const newsletterId = searchParams.get('newsletterId') ?? undefined;
  const hash = searchParams.get('hash') ?? undefined;
  const template = searchParams.get('template') ?? undefined;
  const memberId = searchParams.get('member_id') ?? undefined;
  const type = (searchParams.get('type') ?? undefined) as QueryParams['type'];

  const query = {
    newsletterId,
    hash,
    template,
    member_id: memberId,
    type
  };

  const isLegacy = isLegacyUnsubscription(query);
  const { t } = useTranslation();

  return (
    <>
      <Head {...data} title={t('PAGE_TITLES.NOTIFICATION_UNSUBSCRIBE')} />
      {isLegacy ? <Legacy queryParams={query} /> : <New queryParams={query} />}
    </>
  );
};

export default Unsubscribe;
